






















import { Component, Prop, Vue } from 'vue-property-decorator';

import { Getter } from 'vuex-class';
import { ChannelIdentityViewModel } from '@/messaging/models/channelIdentityViewModel';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import ChannelIcon from '@/shared/icons/ChannelIcon.vue';

@Component({
	components: { DropDownMenu, ChannelIcon }
})
export default class ChannelIdentityPicker extends Vue {
	@Prop() public value: ChannelIdentityViewModel;
	@Getter public channelIdentities: ChannelIdentityViewModel[];

	public mounted() {
		if (this.value) {
			this.chooseOption(this.channelIdentities.find(c => c.id === this.value.id));
		}

		if (!this.value && this.channelIdentities && this.channelIdentities.length > 0) {
			this.chooseOption(this.channelIdentities[0]);
		}
	}

	public chooseOption(identity?: ChannelIdentityViewModel) {
		this.$emit('input', identity);
	}
}
